<template>

    <v-dialog v-model="dialog">
        <v-card style="padding: 15px">
            <v-card-title>Filtros</v-card-title>

            <template v-if="dialog">
                <v-form ref="editSearchDefForm">
                    <v-select v-for="(value, index) in enumsValues" :key="index" :items="value.values" outlined
                        @click:append="removeFilter(value, index)"
                        append-icon="mdi-close"
                        :label="value.field" @input="newValues($event, value.field)"
                        :value="getValuesSearch(index, value.field)">
                    </v-select>
                </v-form>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="red"
                        dark
                        @click="cancelFilter"
                    >
                        Cancelar
                    </v-btn>
                    <v-btn color="green" dark @click="$emit('searchFilter', valueSearch)">
                        Aplicar
                    </v-btn>
                </v-card-actions>
            </template>
        </v-card>
    </v-dialog>

</template>

<script>
export default {
    props: ["open", "schema", "items"],
    watch: {
        open(value){
            this.dialog = value

            this.enumsValues = []
            Object.entries(this.schema.properties).map((item) => {
                if(item[1]?.enum?.length > 0){
                    this.enumsValues.push({ field: item[0], values: [ ...item[1].enum ] })
                }
            })
        },

        schema(){
            this.enumsValues = []
            Object.entries(this.schema.properties).map((item) => {
                if(item[1]?.enum?.length > 0){
                    this.enumsValues.push({ field: item[0], values: [ ...item[1].enum ] })
                }
            })
        }

    },
    data(){
        return {
            dialog: false,
            value: "",
            enumsValues: [],
            valueSearch: [],
            teste: null
        }
    },
    methods: {
        searchFilter(){
            console.log("ITEMS >>> ", this.items)
        },
        newValues(value, field){

            if(this.valueSearch.filter(item => item.field == field).length > 0){
                this.valueSearch.filter(item => item.field == field)[0].search = value
                return
            }

            this.valueSearch.push(
                {
                    search: value,
                    field
                }
            )

        },

        removeFilter(value){
            this.valueSearch = this.valueSearch.filter((item) => item.field != value.field)
        },

        cancelFilter(){
            this.$emit('cancel')
            this.valueSearch = []
        },

        getValuesSearch(position, field){
            console.log(position, field, this.valueSearch)
            return this.valueSearch[position]?.search
        }
    }
}
</script>

<style>

</style>